import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from '../img/Logo.png';
import Resume_Icon from '../img/Resume_Icon.png';
import LinkedIn_Icon from '../img/LinkedIn_Icon.svg';
import GitHub_Icon from '../img/GitHub_Icon.svg';
import Email_Icon from '../img/Email_Icon.png';
import { HashLink } from 'react-router-hash-link';
import links from "../../../assets/data/links.json";
import './Navbar.css';

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (

    <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="/">
          <img src={logo} alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
            <Nav.Link href="#skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>Skills</Nav.Link>
            <Nav.Link href="#tools" className={activeLink === 'tools' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('experience')}>Tools</Nav.Link>
            <Nav.Link href="#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>Projects</Nav.Link>
            <Nav.Link href="#about" className={activeLink === 'about' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('about')}>About</Nav.Link>
          </Nav>
          <span className="navbar-text">
            <div className="social-icon">
              <a href={links.emailLink} ><img src={Email_Icon} alt="Email Icon" /></a>
              <a href={links.linkedinLink} target="_blank" rel="noopener noreferrer"><img src={LinkedIn_Icon} alt="LinkedIn Icon" /></a>
              <a href={links.githubLink} target="_blank" rel="noopener noreferrer"><img src={GitHub_Icon} alt="GitHub Icon" /></a>
              <a href={links.resumeLink} target="_blank" rel="noopener noreferrer"><img src={Resume_Icon} alt="Resume Icon" /></a>
            </div>
            <HashLink to='#connect'>
              <button><span>Let’s Connect</span></button>
            </HashLink>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>

  )
}
